/**
* 银行卡认证 详情
*/
<template>
	<div style="display: flex;flex-direction: column; height: 100vh; margin: 0px 20px;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div>
			<el-alert style="margin:10px 0px;" v-show="successfulOperation" title="操作成功" type="success"
				:description="message" center show-icon>
			</el-alert>
			<el-alert style="margin:10px 0px;" v-show="operationFailed" title="操作失败" type="error" :description="message"
				center show-icon>
			</el-alert>
		</div>


		<el-descriptions title="用户信息" style="padding: 20px; 10px" direction="vertical" :column="3" border>
			<el-descriptions-item label="申请时间">{{ data.createTime }}</el-descriptions-item>
			<el-descriptions-item label="用户ID">{{ data.userId }}</el-descriptions-item>
			<el-descriptions-item label="用户名称">{{ data.nickName }}</el-descriptions-item>
		</el-descriptions>

		<!-- 实名认证的信息 -->
		<el-descriptions title="实名认证信息" style="padding: 20px; 10px" direction="vertical" :column="5" border>
			<el-descriptions-item label="真实姓名">{{ tableData.realName }}</el-descriptions-item>
			<el-descriptions-item label="身份证号码">{{ tableData.idCardNo }}</el-descriptions-item>

			<el-descriptions-item label="身份证正面">
				<a :href="tableData.cardFrontImg" target="_blank">
					<img :src="tableData.cardFrontImg" :alt="tableData.cardFrontImg"
						style="width: 100px; height: 100px; object-fit: contain;" />
				</a>
			</el-descriptions-item>

			<el-descriptions-item label="身份证反面">
				<a :href="tableData.cardBackImg" target="_blank">
					<img :src="tableData.cardBackImg" :alt="tableData.cardBackImg" style="width: 100px; height: 100px; object-fit: contain;" />
				</a>
			</el-descriptions-item>

			<!-- <el-descriptions-item label="手持身份证">
				<a :href="tableData.cardHandImg" target="_blank">
					<img :src="tableData.cardHandImg" :alt="tableData.cardHandImg" style="width: 100px; height: 100px; object-fit: contain;" />
				</a>
			</el-descriptions-item> -->
		</el-descriptions>



		<!-- 国内卡信息展示 -->
		<el-descriptions v-show="data.bankType=='国内'" title="银行卡信息" style="padding: 20px; 10px" direction="vertical"
			:column="5" border>
			<el-descriptions-item label="收款类型">国内卡</el-descriptions-item>
			<el-descriptions-item label="收款账户">{{ data.accountNum }}</el-descriptions-item>
			<el-descriptions-item label="银行名称">{{ data.bankName }}</el-descriptions-item>
			<el-descriptions-item label="支行名称">{{ data.bankSubName }}</el-descriptions-item>
			<!-- <el-descriptions-item label="银行卡照片"><img :src="data.bankImg" :alt="data.bankImg"
					style="width: 100px; height: 100px; object-fit: contain;" /></el-descriptions-item> -->
		</el-descriptions>


		<!-- 国外卡信息展示 -->
		<el-descriptions v-show="data.bankType=='国外'" title="银行卡信息" style="padding: 20px; 10px" direction="vertical"
			:column="5" border>
			<el-descriptions-item label="收款类型">国外卡</el-descriptions-item>
			<el-descriptions-item label="收款账户">{{ data.accountNum }}</el-descriptions-item>
			<el-descriptions-item label="银行名称">{{ data.bankName }}</el-descriptions-item>
			<el-descriptions-item label="支行名称">{{ data.bankSubName }}</el-descriptions-item>
			<!-- <el-descriptions-item label="银行卡照片"><img :src="data.bankImg" :alt="data.bankImg"
					style="width: 100px; height: 100px; object-fit: contain;" /></el-descriptions-item> -->
			<el-descriptions-item label="SWIFT银行识别码">{{ data.swiftCode }}</el-descriptions-item>
			<el-descriptions-item label="银行结算代号">{{ data.bankSettlementCode }}</el-descriptions-item>
		</el-descriptions>

		<!-- 国外卡信息展示 收款人地址-->
		<el-descriptions v-show="data.bankType=='国外'" title="收款人地址" style="padding: 20px; 10px" direction="vertical"
			:column="7" border>
			<el-descriptions-item label=" 国家">{{ data.bankUserCountry }}</el-descriptions-item>
			<el-descriptions-item label=" 城市">{{ data.bankUserCity }}</el-descriptions-item>
			<el-descriptions-item label=" 区域">{{ data.bankUserArea }}</el-descriptions-item>
			<el-descriptions-item label=" 街道">{{ data.bankUserStreet }}</el-descriptions-item>
			<el-descriptions-item label=" 大厦">{{ data.bankUserEdifice }}</el-descriptions-item>
			<el-descriptions-item label=" 楼层">{{ data.bankUserFloor }}</el-descriptions-item>
			<el-descriptions-item label=" 房间号">{{ data.bankUserRoom }}</el-descriptions-item>
		</el-descriptions>

		<!-- 国外卡信息展示 收款银行地址-->
		<el-descriptions v-show="data.bankType=='国外'" title="收款银行地址" style="padding: 20px; 10px" direction="vertical"
			:column="7" border>
			<el-descriptions-item label=" 国家">{{ data.bankCountry }}</el-descriptions-item>
			<el-descriptions-item label=" 城市">{{ data.bankCity }}</el-descriptions-item>
			<el-descriptions-item label=" 区域">{{ data.bankArea }}</el-descriptions-item>
			<el-descriptions-item label=" 街道">{{ data.bankStreet }}</el-descriptions-item>
			<el-descriptions-item label=" 大厦">{{ data.bankEdifice }}</el-descriptions-item>
			<el-descriptions-item label=" 楼层">{{ data.bankFloor }}</el-descriptions-item>
			<el-descriptions-item label=" 房间号">{{ data.bankRoomNum }}</el-descriptions-item>
		</el-descriptions>

		<!-- 按钮+提示 -->
		<el-row v-show="data.verifyStatus==0" type="flex" justify="center" style="padding-bottom: 30px;">
			<span style="width: 2%;" />
			<el-button style="width: 30%;" type="warning" @click="agree()">通过</el-button>
			<span style="width: 3%;" />
			<el-button style="width: 30%;" type="danger" @click="banAccount()">拒绝</el-button>
			<span style="width: 3%;" />
		</el-row>

		<el-row v-show="data.verifyStatus==1" type="flex" justify="center" style="padding-bottom: 30px;">
			<el-button type="success" plain>已通过</el-button>
		</el-row>

		<el-row v-show="data.verifyStatus==2" type="flex" justify="center" style="padding-bottom: 30px;">
			<el-button type="danger" plain>已拒绝</el-button>
		</el-row>


	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				message: "", //提示的内容
				successfulOperation: false, //操作成功
				operationFailed: false, //操作失败
				data: null, //页面传递过来的数据
				tableData: null, //查询语音房用户基础认证信息 数据
			};
		},
		mounted() {
			// 解析传递过来的 JSON 字符串
			this.data = JSON.parse(this.$route.query.data);
			console.log("解析传递过来的：", this.data);
			this.fetchData(); //根据用户id查询语音房用户基础认证信息
		},
		methods: {
			fetchData(pageNum, pageSize) { //根据用户id查询语音房用户基础认证信息
				this.loadingData = true;
				const requestData = {}; //传递的参数
				axios.post(this.$p_url + '/voiceRoom/H5/getVoiceRoomBasicUserInfoByUserId/' + this.data.userId,
						requestData, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
					.then(response => {
						this.loadingData = false;
						console.log("根据用户id查询语音房用户基础认证信息  后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "authFailed") { //登录失效
							Cookies.remove("token");
							this.$router.push({ //跳转到登录
								path: '/Login1715',
								query: {}
							});
						}
						if (state === "success") { // 检查状态
							//身份证正面
							response.data.data.cardFrontImg = this.$p_urlImage + response.data.data.cardFrontImg;
							//身份证反面
							response.data.data.cardBackImg = this.$p_urlImage + response.data.data.cardBackImg;
							//手持身份证
							response.data.data.cardHandImg = this.$p_urlImage + response.data.data.cardHandImg;

							this.tableData = response.data.data;
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			agree() { //通过
				const requestData = {}; //传递的参数
				axios.post(this.$p_url + '/voiceRoom/H5/operateBasicBankInfoVerifyStatus/' + this.data.id +
						'/' + 1, requestData, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
					.then(response => {
						this.loadingData = false;
						console.log("后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.message = "已同意!";
							this.successfulOperation = true;
							this.data.verifyStatus = 1;
						} else {
							this.message = response.data.message;
							this.operationFailed = true;
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			banAccount() { //拒绝
				const requestData = {}; //传递的参数
				axios.post(this.$p_url + '/voiceRoom/H5/operateBasicBankInfoVerifyStatus/' + this.data.id +
						'/' + 2, requestData, {
							withCredentials: true, // 允许跨域携带 cookie
							headers: {
								'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
					.then(response => {
						this.loadingData = false;
						console.log("后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.message = "已拒绝!";
							this.successfulOperation = true;
							this.data.verifyStatus = 2;
						} else {
							this.message = response.data.message;
							this.operationFailed = true;
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			//...
		},
		//...
	}
</script>

<style>
</style>